import { createReducer, on } from '@ngrx/store';

import { IAssistanceSaved, ICaseAssistance } from '../../shared/models/Assistance';
import {
    clearSaveAssistance,
    errorGetOptionsAssistance,
    errorSaveAssistance,
    getOptionsAssistance,
    saveAssistance,
    successGetOptionsAssistance,
    successSaveAssistance,
} from '../actions/assistance.actions';


export interface AssistanceState {
    getOptions: IGetOptionsAssistance;
    saveAssistance: ISaveAssistance;
}

export interface IGetOptionsAssistance {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: ICaseAssistance[];
}

export interface ISaveAssistance {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IAssistanceSaved[];
}


export const AssistanceInit: AssistanceState = {
    getOptions: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        data: []
    },
    saveAssistance: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        data: []
    }
}

const _assistanceReducer = createReducer(
    AssistanceInit,
    on(getOptionsAssistance, (state, { api }) => (
        {
            ...state,
            getOptions: {
                ...state.getOptions,
                loading: true,
                success: false,
                failed: false,
                api
            }
        }
    )),
    on(successGetOptionsAssistance, (state, { data }) => (
        {
            ...state,
            getOptions: {
                ...state.getOptions,
                loading: false,
                success: true,
                data
            }
        }
    )),
    on(errorGetOptionsAssistance, (state, { payload }) => (
        {
            ...state,
            getOptions: {
                ...state.getOptions,
                loading: false,
                failed: true,
                error: { ...payload }
            }
        }
    )),
    on(saveAssistance, (state, { params }) => (
        {
            ...state,
            saveAssistance: {
                ...state.saveAssistance,
                loading: true,
                success: false,
                failed: false,
                params
            }
        }
    )),
    on(successSaveAssistance, (state, { data }) => (
        {
            ...state,
            saveAssistance: {
                ...state.saveAssistance,
                loading: false,
                success: true,
                data
            }
        }
    )),
    on(errorSaveAssistance, (state, { payload }) => (
        {
            ...state,
            saveAssistance: {
                ...state.saveAssistance,
                loading: false,
                failed: true,
                error: { ...payload }
            }
        }
    )),
    on(clearSaveAssistance, (state) => (
        {
            ...state,
            saveAssistance: { ...AssistanceInit.saveAssistance }
        }
    )),
);

export function AssistanceReducer(state: any, action: any) {
    return _assistanceReducer(state, action);
}
